export default "__VITE_PUBLIC_ASSET__232ae7ed__"